import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookACallLink } from "./Header";

export const FloatingCta = ({ heroRef, label, testId = "floating-book-a-call" }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const hero = heroRef.current;
    if (!hero) return;
    const headerH = parseInt(getComputedStyle(hero.closest(".bp-site")).getPropertyValue("--bp-header-h"), 10) || 0;
    const observer = new IntersectionObserver(
      ([entry]) => setVisible(!entry.isIntersecting && entry.boundingClientRect.bottom <= headerH + 1),
      { threshold: 0, rootMargin: `-${headerH + 1}px 0px 0px 0px` }
    );
    observer.observe(hero);
    return () => observer.disconnect();
  }, [heroRef]);

  return (
    <div className={`bp-floating${visible ? " is-visible" : ""}`} aria-hidden={!visible} data-testid="floating-cta-wrap">
      <BookACallLink className="bp-btn bp-btn--floating" testId={testId} label={label} />
    </div>
  );
};

export const Footer = () => (
  <footer className="bp-footer" data-testid="site-footer">
    <div className="bp-wrap bp-footer-inner">
      <div className="bp-footer-legal">
        <p data-testid="footer-copyright">© 2026 The Business Playwright</p>
        <p data-testid="footer-trading-name">The Business Playwright is a trading name of Love Your Work Limited.</p>
        <p data-testid="footer-company-no">Company No. 16472546</p>
      </div>
      <Link to="/privacy-policy" className="bp-footer-link" data-testid="footer-privacy-link">Privacy Policy</Link>
    </div>
  </footer>
);
